/* eslint-disable  @typescript-eslint/no-explicit-any */

export function getMin<T>(items: T[], selector: (x: T) => any) {
  return items
    .map(selector)
    .filter((v) => v)
    .reduce((min, v) => (!min || v < min ? v : min), null);
}

export function getMax<T>(items: T[], selector: (x: T) => any) {
  return items
    .map(selector)
    .filter((v) => v)
    .reduce((max, v) => (!max || v > max ? v : max), null);
}

export function unique<T>(items: T[]): T[] {
  return [...new Set(items)];
}

export function joinNonEmpty(values: (string | false | null | undefined)[], separator = ' '): string {
  return values.filter(Boolean).join(separator);
}

export function sum(items: number[]): number;
export function sum<T>(items: T[], selector: (item: T) => number): number;
export function sum<T>(items: T[], selector?: (item: T) => number): number {
  if (!selector) return (items as number[]).reduce((a, b) => a + b, 0);
  return items.reduce((total, item) => total + selector(item), 0);
}

export function getCopyRangeItems(
  visibleItems: string[],
  sourceItem: string | undefined,
  targetItem: string | undefined
): string[] {
  if (!sourceItem || !targetItem || sourceItem === targetItem) {
    return [];
  }

  const sourceIndex = visibleItems.indexOf(sourceItem);
  const targetIndex = visibleItems.indexOf(targetItem);
  if (sourceIndex < 0 || targetIndex < 0) {
    return [];
  }

  const fromIndex = Math.min(sourceIndex, targetIndex);
  const toIndex = Math.max(sourceIndex, targetIndex);
  return visibleItems.slice(fromIndex, toIndex + 1).filter((item) => item !== sourceItem);
}

export function replaceMatchingInOrder<T>(items: T[], isMatch: (item: T) => boolean, replacements: T[]): T[] {
  let replacementIndex = 0;
  const replaced = items.flatMap((item) => {
    if (!isMatch(item)) {
      return [item];
    }

    return replacementIndex < replacements.length ? [replacements[replacementIndex++]] : [];
  });

  return [...replaced, ...replacements.slice(replacementIndex)];
}
